import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import {
  TextEditorComponent,
  Destination,
  DestinationService,
  Picture,
} from '../../shared/public-api';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'admin-destinations',
  templateUrl: './destinations.component.html',
  styleUrls: ['./destinations.component.scss'],
  imports: [
    CommonModule,
    TableModule,
    DialogModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    SelectModule,
    TextEditorComponent,
  ],
})
export class DestinationsComponent implements OnInit {
  @ViewChild('coverPicture') coverPictureInput!: ElementRef;
  @ViewChild('coverPictureUpdate') coverPictureUpdateInput!: ElementRef;

  baseUrl: string;

  destinationModel!: Destination;
  destinations: Destination[] = [];
  update!: boolean;

  constructor(private destinationService: DestinationService) {
    this.baseUrl = environment.baseUrl;
  }

  ngOnInit(): void {
    this.destinationModel = new Destination();
    this.getDestinations();
  }

  getDestinations(): void {
    this.destinationService.getDestinations().subscribe((destinations) => {
      this.destinations = destinations;
    });
  }

  onFileChanged(event: Event): void {
    const files = (event.target as HTMLInputElement)?.files;
    if (!files || files?.length === 0) {
      return;
    }
    const file = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.destinationModel.coverPicture.uploadSrc = reader.result as string;
    };
    const picture = new Picture(0);
    picture.name = file.name;
    this.destinationModel.coverPicture = picture;
  }

  deleteDestination(destination: Destination): void {
    this.destinationService
      .deleteDestination(destination.id)
      .pipe(
        finalize(() => (this.destinations = this.destinations.filter((d) => d !== destination)))
      )
      .subscribe((res) => {
        if (res) {
          console.log('deleted!');
        }
      });
  }

  createDestination(): void {
    this.destinationModel = new Destination();
    this.update = true;
  }

  updateDestination(destination: Destination): void {
    this.destinationModel = Object.assign({}, destination);
    this.update = true;
  }

  updateDestinationSave(): void {
    if (this.destinationModel.id) {
      this.destinationService
        .updateDestination(this.destinationModel)
        .pipe(
          finalize(() => {
            this.coverPictureUpdateInput.nativeElement.value = '';
            this.update = false;
          })
        )
        .subscribe((destination) => {
          this.getDestinations();
        });
    } else {
      this.destinationService
        .createDestination(this.destinationModel)
        .pipe(
          finalize(() => {
            this.update = false;
            this.coverPictureInput.nativeElement.value = '';
          })
        )
        .subscribe((destination) => {
          this.destinations.push(destination);
        });
    }
  }
}
